import React, { useContext, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { UserContext } from '../context/User';
import { API, showError } from '../helpers';
import Loading from './Loading';

const SSOCallback = () => {
  const [searchParams] = useSearchParams();
  const [, userDispatch] = useContext(UserContext);
  const navigate = useNavigate();

  useEffect(() => {
    const redirect = searchParams.get('redirect') || '/token';

    API.get('/api/user/self')
      .then((res) => {
        const { success, data } = res.data;
        if (success) {
          userDispatch({ type: 'login', payload: data });
          localStorage.setItem('user', JSON.stringify(data));
          navigate(redirect, { replace: true });
        } else {
          showError('SSO 登录失败，请重试');
          navigate('/login', { replace: true });
        }
      })
      .catch(() => {
        showError('SSO 登录失败，请重试');
        navigate('/login', { replace: true });
      });
  }, []);

  return <Loading />;
};

export default SSOCallback;
